import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';
import auth from './authReducer';
import budgetAuth from './budgetAuthReducer';
import unit from './unitReducer';
import notifications from './notificationsReducer';
import budget from './budgetReducer';
import budgetVoting from './budgetVotingReducer';
import cms from './cmsReducer';
import teryt from './terytReducer';
import publicSurveys from './publicSurveysReducer';
import publicSurveyDetails from './publicSurveyDetailsReducer';
import publicSurveyVerification from './publicSurveyVerificationReducer';
import account from './accountReducer';
import theme from './themeReducer';
import boardThreads from './boardThreadsReducer';
import boardThreadDetails from './boardThreadDetailsReducer';
import budgetApplications from './budgetApplicationsReducer';
import budgetApplicationDetails from './budgetApplicationDetailsReducer';
import budgetAccount from './budgetAccountReducer';

const appReducer = history => combineReducers({
  auth,
  notifications,
  routing: routerReducer,
  form: formReducer,
  unit,
  budget,
  cms,
  budgetVoting,
  teryt,
  publicSurveys,
  publicSurveyDetails,
  publicSurveyVerification,
  router: connectRouter(history),
  theme,
  account,
  boardThreads,
  boardThreadDetails,
  budgetApplications,
  budgetApplicationDetails,
  budgetAuth,
  budgetAccount
});

const rootReducer = history => (state, action) => {
  return appReducer(history)(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js